import { Box, Flex, Text } from '@chakra-ui/react'
import { Link } from 'react-router-dom'

export function Propostas({ valor, lineColor, ...rest }) {
  return (
    <Box
      position="relative"
      cursor="pointer"
      as={Link}
      to={rest.to}
      sx={{
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '0',
          height: '2px',
          backgroundColor: `${lineColor}`,
          transition: 'width 0.3s ease-in-out',
        },
      }}
      _hover={{
        '&::after': {
          width: '100%',
        },
      }}
    >
      <Box
        position="absolute"
        left={'-10px'}
        top="16px"
        height="50%"
        width="3px"
        bgColor={lineColor}
      />
      <Flex flexDir="column">
        <Text
          as="span"
          fontSize="14px"
          color="#2d2d2d"
          textTransform="lowercase"
        >
          Propostas
        </Text>
        <Text
          as="span"
          fontSize="14px"
          color="#2d2d2d"
          textTransform="lowercase"
        >
          {rest.text}{' '}
          <Text as="strong" textTransform="initial">
            R$ {valor} mil
          </Text>
        </Text>
      </Flex>
    </Box>
  )
}
